import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "file-local-upload" }
const _hoisted_2 = { class: "file-local-upload__list" }
const _hoisted_3 = { class: "file-local-upload__text" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _component_FileBaseMultiUploadRedesigned = _resolveComponent("FileBaseMultiUploadRedesigned")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.title)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.headingLevel), {
          key: 0,
          class: "file-local-upload__title"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.title), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.subtitle)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.subHeadingLevel), {
          key: 1,
          class: "file-local-upload__subtitle"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.subtitle), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_FileBaseMultiUploadRedesigned, {
      class: "file-local-upload__file",
      modelValue: _ctx.value,
      label: _ctx.label,
      isOnce: _ctx.isOnce,
      readonly: _ctx.readonly,
      required: _ctx.required,
      accept: _ctx.accept,
      showEmpty: _ctx.showEmpty,
      description: _ctx.description,
      validExtensions: _ctx.validExtensions,
      disabled: _ctx.disabled,
      onAddFile: _ctx.addFile
    }, {
      preview: _withCtx(() => [
        _createElementVNode("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.value, (file, i) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "file-local-upload__item",
              key: i
            }, [
              _createElementVNode("p", _hoisted_3, _toDisplayString(file.name), 1),
              (!_ctx.readonly && !_ctx.disabled)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "file-local-upload__button",
                    onClick: ($event: any) => (_ctx.deleteFile(i))
                  }, [
                    _createVNode(_component_IconComponent, {
                      title: "Удалить",
                      name: "closeCross"
                    })
                  ], 8, _hoisted_4))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "label", "isOnce", "readonly", "required", "accept", "showEmpty", "description", "validExtensions", "disabled", "onAddFile"])
  ]))
}